import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";
export const RecognitionSlice = createSlice({
 name: "recognition",
 initialState: {
  error: false,

  recognitionMail: "",
  isRecognitionLoaded: false,
 },
 reducers: {
  setRecognitionMail: (state, { payload }) => {
   state.recognitionMail = payload;
   state.isRecognitionLoaded = true;
  },

  setError: (state) => {
   state.error = true;
  },

  setRecognitionLoad: (state) => {
   state.isRecognitionLoaded = false;
  },
 },
});

// Action creators are generated for each case reducer function
export const { setError, setRecognitionMail, setRecognitionLoad } =
 RecognitionSlice.actions;

export default RecognitionSlice.reducer;

export function handleGenerateRecognition(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/recognition/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setRecognitionMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleRecognitionLoading() {
 return (dispatch) => {
  dispatch(setRecognitionLoad());
 };
}
